var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x36_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FCE81"
    },
    d: "M148.413,10.054v387.402c0,5.519-4.536,10.056-10.056,10.056H10.056 C4.537,407.512,0,402.975,0,397.456V10.054C0,4.535,4.537,0,10.056,0h128.302C143.877,0,148.413,4.535,148.413,10.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FCE81"
    },
    d: "M96.848,244.003H51.57c-16.602,0-30.185-13.583-30.185-30.185V77.983 c0-16.602,13.583-30.185,30.185-30.185h45.278c16.602,0,30.185,13.583,30.185,30.185v135.834 C127.034,230.419,113.45,244.003,96.848,244.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M112.57,244.003H35.849c-7.955,0-14.464-6.509-14.464-14.464V62.262 c0-7.955,6.509-14.464,14.464-14.464h76.721c7.955,0,14.464,6.509,14.464,14.464v167.277 C127.034,237.494,120.525,244.003,112.57,244.003z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#040000"
    },
    d: "M74.209,384.194c-21.486,0-38.967-17.481-38.967-38.967 c0-21.486,17.481-38.967,38.967-38.967s38.967,17.481,38.967,38.967C113.176,366.714,95.696,384.194,74.209,384.194z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 74.209,
    cy: 345.227,
    r: 27.277
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40.251,
    y: 80.499,
    style: {
      fill: "#9FCE81"
    },
    width: 67.917,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.251,
    y: 129.55,
    style: {
      fill: "#9FCE81"
    },
    width: 67.917,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.251,
    y: 178.601,
    style: {
      fill: "#9FCE81"
    },
    width: 67.917,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    y: 268.021,
    style: {
      fill: "#FFFFFF"
    },
    width: 148.413,
    height: 14.818
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8B674"
    },
    d: "M330.169,10.054v387.402c0,5.519-4.461,10.056-10.055,10.056H191.886 c-5.595,0-10.056-4.537-10.056-10.056V10.054C181.831,4.535,186.292,0,191.886,0h128.227C325.708,0,330.169,4.535,330.169,10.054z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8B674"
    },
    d: "M278.639,244.003h-45.278c-16.602,0-30.185-13.583-30.185-30.185V77.983 c0-16.602,13.583-30.185,30.185-30.185h45.278c16.602,0,30.185,13.583,30.185,30.185v135.834 C308.824,230.419,295.241,244.003,278.639,244.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.36,244.003h-76.721c-7.955,0-14.464-6.509-14.464-14.464V62.262 c0-7.955,6.509-14.464,14.464-14.464h76.721c7.955,0,14.464,6.509,14.464,14.464v167.277 C308.824,237.494,302.315,244.003,294.36,244.003z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#040000"
    },
    d: "M256,384.194c-21.486,0-38.967-17.481-38.967-38.967 c0-21.486,17.481-38.967,38.967-38.967c21.486,0,38.967,17.481,38.967,38.967C294.967,366.714,277.486,384.194,256,384.194z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 345.227,
    r: 27.277
  })), /*#__PURE__*/React.createElement("rect", {
    x: 222.041,
    y: 80.499,
    style: {
      fill: "#E8B674"
    },
    width: 67.917,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.041,
    y: 129.55,
    style: {
      fill: "#E8B674"
    },
    width: 67.917,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.041,
    y: 178.601,
    style: {
      fill: "#E8B674"
    },
    width: 67.917,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.794,
    y: 268.018,
    style: {
      fill: "#FFFFFF"
    },
    width: 148.412,
    height: 14.857
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AB5AE"
    },
    d: "M512,10.054v387.402c0,5.519-4.537,10.056-10.056,10.056H373.642 c-5.519,0-10.055-4.537-10.055-10.056V10.054C363.587,4.535,368.123,0,373.642,0h128.303C507.463,0,512,4.535,512,10.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AB5AE"
    },
    d: "M460.429,244.003h-45.278c-16.602,0-30.185-13.583-30.185-30.185V77.983 c0-16.602,13.583-30.185,30.185-30.185h45.278c16.602,0,30.185,13.583,30.185,30.185v135.834 C490.615,230.419,477.031,244.003,460.429,244.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M476.151,244.003H399.43c-7.955,0-14.464-6.509-14.464-14.464V62.262 c0-7.955,6.509-14.464,14.464-14.464h76.721c7.955,0,14.464,6.509,14.464,14.464v167.277 C490.615,237.494,484.106,244.003,476.151,244.003z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#040000"
    },
    d: "M437.79,384.194c-21.486,0-38.967-17.481-38.967-38.967 c0-21.486,17.481-38.967,38.967-38.967c21.486,0,38.967,17.481,38.967,38.967C476.757,366.714,459.276,384.194,437.79,384.194z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 437.79,
    cy: 345.227,
    r: 27.277
  })), /*#__PURE__*/React.createElement("rect", {
    x: 403.832,
    y: 80.499,
    style: {
      fill: "#8AB5AE"
    },
    width: 67.917,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.832,
    y: 129.55,
    style: {
      fill: "#8AB5AE"
    },
    width: 67.917,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.832,
    y: 178.601,
    style: {
      fill: "#8AB5AE"
    },
    width: 67.917,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.584,
    y: 268.018,
    style: {
      fill: "#FFFFFF"
    },
    width: 148.412,
    height: 14.857
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.08
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#040000"
    },
    points: "148.415,407.507 148.415,311.341 52.248,407.507  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#040000"
    },
    points: "181.794,282.874 181.794,407.507 330.206,407.507 330.206,282.874 330.206,268.017  330.206,129.55 181.794,277.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#040000"
    },
    points: "459.751,0.004 363.584,96.172 363.584,268.017 363.584,282.874 363.584,407.507  511.996,407.507 511.996,282.874 511.996,268.017 511.996,0.004  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBox);
export default __webpack_public_path__ + "static/media/file-box.5638d26b4c4fc91aeef9a48e096590d8.svg";
export { ForwardRef as ReactComponent };